export interface Role {
  id: number;
  permissions: Array<GroupPermission>;
  createdAt: string;
  updatedAt: string;
  name: RoleType;
  createdBy: string;
  updatedBy: string;
  domain: number;
  users: Array<string>;
}

export enum RoleType {
  L1 = 'L1',
  L2 = 'L2',
  L3 = 'L3',
  ADMIN = 'ADMIN',
  SUPER_ADMIN = 'SUPER ADMIN'
}

export interface RolePermissionMap {
  l1: Role;
  l2: Role;
  l3: Role;
  admin: Role;
}

export interface GroupPermission {
  id: number;
  createdAt: string;
  updatedAt: string;
  action: string;
  resource: string;
  createdBy: string;
  updatedBy: string;
}
